import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { SignUpForm } from '../components';

export const SignUpRaw = ({ toRoot }) =>
  <div>
    <h1>SignUp</h1>
    <SignUpForm onSignIn={toRoot}/>
  </div>

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => bindActionCreators({
  toRoot: () => push('/')
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpRaw)




// WEBPACK FOOTER //
// ./src/pages/SignUp.js